export default "__VITE_ASSET__Xh7iiKOl__"